export default "__VITE_ASSET__eH$4YAeR__"